var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckuiliGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4519_6578)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4519_6578",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0H0V34H34V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4519_6578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0516 13.9942C29.2908 14.9567 29.4178 15.9635 29.4178 17C29.4178 23.8582 23.8581 29.4179 16.9999 29.4179C10.1417 29.4179 4.58203 23.8582 4.58203 17C4.58203 10.1418 10.1417 4.58215 16.9999 4.58215C19.7587 4.58215 22.3074 5.48179 24.3685 7.0037",
    stroke: "#A3BD61",
    strokeWidth: 1.36,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5698 14.746C13.0519 17.4175 16.0172 20.6091 16.0172 20.6091C16.0172 20.6091 23.9161 13.2475 27.3492 10.048",
    stroke: "#A3BD61",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4519_6578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckuiliGreen);
export default __webpack_public_path__ + "static/media/checkuili_green.c31764e104168e91c7782e26d66db930.svg";
export { ForwardRef as ReactComponent };